var React = require('react');

function ProfileV2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7.575 24.522A11.97 11.97 0 0 0 16.5 28.5c3.636 0 6.893-1.617 9.094-4.17a4.15 4.15 0 0 0-4.564-1.647 15.956 15.956 0 0 1-8.767 0 4.15 4.15 0 0 0-4.688 1.839zm-1.264-1.68a6.15 6.15 0 0 1 6.501-2.082c2.506.716 5.162.716 7.668 0a6.136 6.136 0 0 1 6.327 1.89A11.944 11.944 0 0 0 28.5 16.5c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 2.329.663 4.503 1.811 6.343zM16.5 31.5c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-12.413a5.696 5.696 0 1 1 0-11.391 5.696 5.696 0 0 1 0 11.391zm0-2a3.696 3.696 0 1 0 0-7.391 3.696 3.696 0 0 0 0 7.391z"}));
}

ProfileV2.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ProfileV2;

ProfileV2.default = ProfileV2;
